import { render, staticRenderFns } from "./ModalRegister.vue?vue&type=template&id=36b738af&"
import script from "./ModalRegister.vue?vue&type=script&lang=js&"
export * from "./ModalRegister.vue?vue&type=script&lang=js&"
import style0 from "./ModalRegister.vue?vue&type=style&index=0&id=36b738af&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GDPRConsent: require('/home/smiley/3df/components/GDPRConsent.vue').default})
